import { useRef as c } from "react";
const n = (r, e) => !Object.is(r, e), s = (r, e = n) => {
  const u = c(), t = c();
  return e(t.current, r) && (u.current = t.current, t.current = r), u.current;
};
export {
  s as default
};
//# sourceMappingURL=usePrevious.js.map
